import { LandingsRoutes } from '@/shared/types/router.types'

export const getHomeUrl = (
  locale: string,
  redirectURL: string | null,
  isInboundRoute?: boolean
) => {
  if (redirectURL) return redirectURL
  const currentParams = new URLSearchParams(window.location.href)
  const lastUrlPath = isInboundRoute
    ? `inbound-${LandingsRoutes.TRAVEL_MAIN}`
    : LandingsRoutes.TRAVEL_MAIN
  const resultUrl = new URL(`${window.origin}/${locale}/${lastUrlPath}`)
  const storedKeys = JSON.parse(sessionStorage.getItem('urlParamsKey') || '[]')

  storedKeys.forEach((key: string) => {
    let value: string | null = null
    const valueFromUrl = currentParams.get(key)
    if (valueFromUrl) {
      sessionStorage.setItem(key, valueFromUrl)
      value = valueFromUrl
    } else {
      const valueFromStorage = sessionStorage.getItem(key)
      if (valueFromStorage) {
        value = valueFromStorage
      }
    }

    if (value) {
      resultUrl.searchParams.append(key, value)
    }
  })
  return resultUrl.href
}
